import PriceSection from '~valuation/pages/MyValuations/PriceSection';
import PropertyDetailsSection from '~valuation/pages/MyValuations/PropertyDetailsSection';
import ValuationUpdatedDate from '~valuation/pages/MyValuations/ValuationUpdatedDate';
import ValuationItemLoader from '~valuation/pages/MyValuations/ValuationItemLoader';
import PortfolioFooter from '~valuation/pages/MyValuations/Portfolios/PortfolioFooter';
import { ValuationItemType } from '~/types/valuationTypes';
import { useNavigate } from 'react-router-dom';
import { useFullRoutes } from '~/hooks';

export default function PortfoliosList({
  portfolios,
  isFetching,
}: {
  portfolios: ValuationItemType[];
  isFetching?: boolean;
}) {
  const navigate = useNavigate();
  const { VALUATION_URL } = useFullRoutes();

  if (isFetching) {
    return (
      <div className="flex flex-col gap-3x">
        {Array(2)
          .fill(0)
          .map((_, i) => (
            <ValuationItemLoader showFooter={true} key={i} />
          ))}
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-3x">
      {portfolios.map((portfolio: ValuationItemType) => {
        return (
          <div
            key={portfolio.id}
            className="tab-content-item cursor-pointer"
            role="button"
            onClick={() => navigate(VALUATION_URL.RESULTS(portfolio.id))}
          >
            <div className="flex flex-col-reverse md:flex-row md:justify-between gap-1.5x">
              <div className="flex flex-col gap-2x ">
                <PropertyDetailsSection
                  location={portfolio.location.titleShortPath}
                  propertyType={portfolio.propertyType.titleSingular}
                />
                <PriceSection
                  price={portfolio.currentValuation?.valuationPrice ?? 0}
                  labelKey={'estimatedPriceNow'}
                />
              </div>
              <div className="flex h-full items-center justify-between gap-2x ">
                <ValuationUpdatedDate date={portfolio.updatedAt} />
              </div>
            </div>
            <PortfolioFooter
              id={portfolio.id}
              yearlyChangePercentage={portfolio.yearlyChangePercentage}
              unrealizedGainPercentage={portfolio.unrealizedGainPercentage}
              unrealizedGain={portfolio.unrealizedGain}
            />
          </div>
        );
      })}
    </div>
  );
}
